import { useCallback, useMemo } from "react";
import type { ExplorerItem } from "../types";
import { summarizeTree, isTaskItemLockedByOther } from "../utils/item-lock";

export const useItemLockState = (items: readonly ExplorerItem[], currentUserId: string | null) => {
  const isItemLockedByOther = useCallback(
    (item: ExplorerItem) => isTaskItemLockedByOther(item, currentUserId),
    [currentUserId]
  );

  const summary = useMemo(() => summarizeTree(items, currentUserId), [items, currentUserId]);

  return { ...summary, isItemLockedByOther };
};
